var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Formio } from 'formiojs';
import editFormAddons from './editForm/ZipcodePostcodeAPI.edit.addons';
import editFormProvider from './editForm/ZipcodePostcodeAPI.edit.provider';
import { delay } from 'formiojs/utils/utils';
var Components = Formio.Components;
var TextFieldComponent = Formio.Components.components.textfield;
/**
 * ZipcodePostcodeAPI class extending from a formio field base component
 *
 * @author Raphaël OLIVERO <@RaphaelOlivero>
 * @copyright Novti - 2022
 */
var ZipcodePostcodeAPI = /** @class */ (function (_super) {
    __extends(ZipcodePostcodeAPI, _super);
    /**
     * Called when the component has been instantiated. This is useful to define
     * default instance variable values.
     *
     * @param component - The JSON representation of the component created.
     * @param options - The global options for the renderer
     * @param data - The contextual data object (model) used for this component.
     */
    function ZipcodePostcodeAPI(component, options, data) {
        return _super.call(this, component, options, data) || this;
    }
    /**
     * Called immediately after the component has been instantiated to initialize
     * the component.
     */
    ZipcodePostcodeAPI.prototype.init = function () {
        _super.prototype.init.call(this);
    };
    /**
     * This is the default schema of your custom component. It will "derive"
     * from the base class "schema" and extend it with its default JSON schema
     * properties. The most important are "type" which will be your component
     * type when defining new components.
     *
     * @param extend - This allows classes deriving from this component to
     *                 override the schema of the overridden class.
     */
    ZipcodePostcodeAPI.schema = function () {
        var extend = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extend[_i] = arguments[_i];
        }
        return TextFieldComponent.schema.apply(TextFieldComponent, __spreadArrays([{
                label: 'Zipcode (Postcode API)',
                key: 'zipcodePostcodeAPI',
            }], extend));
    };
    Object.defineProperty(ZipcodePostcodeAPI, "builderInfo", {
        /**
         * This is the Form Builder information on how this component should show
         * up within the form builder. The "title" is the label that will be given
         * to the button to drag-and-drop on the buidler. The "icon" is the font awesome
         * icon that will show next to it, the "group" is the component group where
         * this component will show up, and the weight is the position within that
         * group where it will be shown. The "schema" field is used as the default
         * JSON schema of the component when it is dragged onto the form.
         */
        get: function () {
            return {
                title: 'Zipcode (Postcode API)',
                icon: 'terminal',
                group: 'basic',
                documentation: '/userguide/#input',
                weight: 0,
                schema: ZipcodePostcodeAPI.schema()
            };
        },
        enumerable: false,
        configurable: true
    });
    ZipcodePostcodeAPI.prototype.addFocusBlurEvents = function (element) {
        var _this = this;
        this.addEventListener(element, 'focus', function () {
            if (_this.root.focusedComponent !== _this) {
                if (_this.root.pendingBlur) {
                    _this.root.pendingBlur();
                }
                _this.root.focusedComponent = _this;
                _this.emit('focus', _this);
            }
            else if (_this.root.focusedComponent === _this && _this.root.pendingBlur) {
                _this.root.pendingBlur.cancel();
                _this.root.pendingBlur = null;
            }
        });
        this.addEventListener(element, 'blur', function () {
            _this.root.pendingBlur = delay(function () {
                _this.emit('blur', _this);
                if (_this.component.validateOn === 'blur') {
                    _this.root.triggerChange({ fromBlur: true }, {
                        instance: _this,
                        component: _this.component,
                        value: _this.dataValue,
                        flags: { fromBlur: true }
                    });
                }
                _this.root.focusedComponent = null;
                _this.root.pendingBlur = null;
            });
        });
        // Postcode API elements
        var cityElement = document.getElementsByClassName('formio-component-cityPostcodeAPI')[0];
        var streetElement = document.getElementsByClassName('formio-component-streetPostcodeAPI')[0];
        var houseNumberElement = document.getElementsByClassName('formio-component-houseNumberPostcodeAPI')[0];
        // If the dependent elements (i.e. street and city) are not loaded, abort
        if (streetElement === undefined || cityElement === undefined || houseNumberElement === undefined) {
            return;
        }
        var retrieveAddress = function () {
            // If we do not have the necessary input, abort
            if (!_this.getValue() || !_this.data.houseNumberPostcodeAPI) {
                return;
            }
            // Compose the Postcode API path
            var postcodeApiRequestUrl = encodeURIComponent(_this.component.providerOptions.apiBaseUrl) + "/" + _this.getValue() + "/" + _this.data.houseNumberPostcodeAPI;
            // Compose the API path
            var requestUrl = "/integrations/" + _this.component.provider + "/?url=" + postcodeApiRequestUrl;
            fetch(requestUrl)
                .then(function (response) { return response.json(); })
                .then(function (address) { return _this.data.postcodeApiAddress = address; })
                .catch(function (error) {
                _this.data.postcodeApiAddress = {
                    exception: error.message,
                };
                // For dev purpose
                if (!/^https?:/i.test(document.location.protocol)) {
                    _this.data.postcodeApiAddress = __assign(__assign({}, _this.data.postcodeApiAddress), { street: '2311 North Los Robles Avenue', streetNen: '2311 North Los Robles Avenue', houseNumber: 4, houseNumberAddition: null, postcode: 'CA91104', city: 'California', houseNumberAdditions: [
                            'A',
                            'B'
                        ] });
                }
            })
                .finally(function () {
                var _a, _b, _c, _d, _e;
                // Compose the house number additions datalist
                if (((_b = (_a = _this.data) === null || _a === void 0 ? void 0 : _a.postcodeApiAddress) === null || _b === void 0 ? void 0 : _b.houseNumberAdditions) && ((_e = (_d = (_c = _this.data) === null || _c === void 0 ? void 0 : _c.postcodeApiAddress) === null || _d === void 0 ? void 0 : _d.houseNumberAdditions) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                    var optionList = _this.data.postcodeApiAddress.houseNumberAdditions;
                    var datalistElement = document.getElementById('house-number-additions-datalist');
                    if (datalistElement === undefined || datalistElement === null) {
                        datalistElement = document.createElement('datalist');
                        datalistElement.id = 'house-number-additions-datalist';
                    }
                    // Remove existing elements
                    datalistElement.innerHTML = '';
                    for (var _i = 0, optionList_1 = optionList; _i < optionList_1.length; _i++) {
                        var item = optionList_1[_i];
                        var option = document.createElement('option');
                        if (item === '') {
                            continue;
                        }
                        option.value = item;
                        datalistElement.appendChild(option);
                    }
                    document.body.appendChild(datalistElement);
                }
                _this.triggerRootChange();
            });
        };
        // Listen to the Postcode API zipcode element
        this.addEventListener(element, 'blur', function () {
            _this.root.pendingBlur = delay(function () {
                _this.emit('blur', _this);
                retrieveAddress();
                _this.root.focusedComponent = null;
                _this.root.pendingBlur = null;
            });
        });
        // Listen to the Postcode API house number element as well
        houseNumberElement.querySelector('input').addEventListener('blur', function () { retrieveAddress(); }, false);
    };
    ZipcodePostcodeAPI.prototype.render = function (children) {
        return _super.prototype.render.call(this, this.renderTemplate('zipcodepostcodeapi'));
    };
    ZipcodePostcodeAPI.prototype.waitForElm = function (selector) {
        return new Promise(function (resolve) {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            var observer = new MutationObserver(function (mutations) {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    };
    /**
     * Sets the value of both the data and view of the component (such as setting the
     * <input> value to the correct value of the data. This is most commonly used
     * externally to set the value and also see that value show up in the view of the
     * component. If you wish to only set the data of the component, like when you are
     * responding to an HMTL input event, then updateValue should be used instead since
     * it only sets the data value of the component and not the view.
     *
     * @param value - The value that is being set for this component's data and view.
     * @param flags - Change propogation flags that are being used to control behavior of the
     *                change proogation logic.
     *
     * @return - Boolean indicating if the setValue changed the value or not.
     */
    ZipcodePostcodeAPI.prototype.setValue = function (value, flags) {
        if (flags === void 0) { flags = {}; }
        return _super.prototype.setValue.call(this, value, flags);
    };
    /**
     * Returns the value of the "view" data for this component.
     *
     * @return - The value for this whole component.
     */
    ZipcodePostcodeAPI.prototype.getValue = function () {
        return _super.prototype.getValue.call(this);
    };
    return ZipcodePostcodeAPI;
}(TextFieldComponent));
export default ZipcodePostcodeAPI;
ZipcodePostcodeAPI.editForm = function () {
    return TextFieldComponent.editForm(__spreadArrays(editFormAddons, editFormProvider));
};
Components.addComponent('zipcodepostcodeapi', ZipcodePostcodeAPI);
